__turbopack_context__.v({
  "discount": "QdMqFq_discount",
  "discount-config": "QdMqFq_discount-config",
  "discount-large": "QdMqFq_discount-large",
  "old-price": "QdMqFq_old-price",
  "original-price-row": "QdMqFq_original-price-row",
  "product-price-plp": "QdMqFq_product-price-plp",
  "row-discount": "QdMqFq_row-discount",
  "subtotal-price": "QdMqFq_subtotal-price",
  "subtotal-price-config-discount": "QdMqFq_subtotal-price-config-discount",
  "subtotal-price-large": "QdMqFq_subtotal-price-large",
  "suggestedSetPrice": "QdMqFq_suggestedSetPrice",
  "total-price": "QdMqFq_total-price",
  "total-price-config": "QdMqFq_total-price-config",
  "total-price-large": "QdMqFq_total-price-large",
});
